import { api } from "..";
import { SimpleSuccessResponse } from "./types";

export const markChatAsSeen = async (
  chatId: number
): Promise<SimpleSuccessResponse> => {
  const res = await api.client.patch(`/chats/${chatId}/seen`);
  return res.data;
};
